import React from 'react';
import { colors } from '@guryou/colors';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { cognitoLogout } from '@guryou/redux';

const InvalidUser = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const handleLogin = () => {
    dispatch(cognitoLogout());
    history.push('/login', {
      from: location,
      forceLogin: true,
    });
  };

  return (
    <div className={`mx-auto w-full h-full p-4 sm:p-8 flex flex-col items-center justify-center gap-4`} style={{ backgroundColor: colors.mineShaft }}>
      <h2 className="text-white text-xl font-semibold">Access Denied</h2>

      <p className="text-gray-300 text-sm text-center max-w-md">This user does not match the expected credentials or the link may be invalid.</p>

      <button onClick={handleLogin} className="mt-2 px-6 py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white font-medium transition">
        Login as a different user
      </button>
    </div>
  );
};

export default InvalidUser;
